import React, { Component } from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';

// Utils
import { KEYS } from 'Utils/window-key-down';
import { getImageObjectFromSection } from 'Utils/image-util';
import { pushPathToHistory } from 'Utils/history';

// Components
import PrivateIcon from 'ComponentLibrary/icons/private';
import SectionLink from './section-link';
import Image from './base/image';
import SmartMagazineControls from 'Webapp/shared/app/containers/smart-magazine-controls';
import withSelected from 'Webapp/shared/app/hocs/withSelected';
import { ItemActionButtonType } from 'Webapp/enums';

import connector from 'Utils/connector';
import connectModal from 'Webapp/shared/app/connectors/connectModal';
import connectUsageTrackSectionTap from 'Webapp/shared/app/connectors/connectUsageTrackSectionTap';
import withT from 'ComponentLibrary/hocs/withT';
import withHistory from 'Webapp/shared/app/hocs/withHistory';

class SmartMagazineTile extends Component {
  constructor(props) {
    super(props);

    this.tile = React.createRef();
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedId === this.props.selectedId) {
      return;
    }
    if (this.props.section.remoteid === this.props.selectedId) {
      this.tile.current.focus();
    }
  }

  handleKeyPress(event) {
    switch (event.keyCode) {
      case KEYS.ENTER: {
        const { history, section } = this.props;
        const sectionPath = section.canonicalPath;
        sectionPath && pushPathToHistory(sectionPath, history);
        break;
      }
    }
  }

  render() {
    const { section, selectedId, usageTrackSectionTap, t } = this.props;
    const isSelected = selectedId === section.remoteid;
    const { title } = section;
    const selectedClass = className({
      'section-tiles__tile-wrapper': true,
      'section-tiles__tile-wrapper--selected': isSelected,
    });
    const alt = title ? `${title} - ${t('cover')}` : t('smart_magazine_cover');
    const tileProps = { ref: this.tile };
    if (isSelected) {
      tileProps.tabIndex = 0;
      tileProps.onKeyDown = this.handleKeyPress;
    }
    const image = getImageObjectFromSection(section);

    const buttonSet = [
      ItemActionButtonType.PERSONALIZE_TEXT,
      ItemActionButtonType.ADD_FAVORITE,
    ];
    return (
      <div {...tileProps} className={selectedClass}>
        <SectionLink
          className="section-tiles__tile media-link"
          section={section}
          onClick={usageTrackSectionTap}
        >
          <div className="section-tiles__image">
            {image && <Image image={image} ampHeight={220} alt={alt} crop />}
          </div>
          <div className="section-tiles__tile-overlay" />
          <div className="section-tiles__tile-content">
            <h3 className="section-tiles__title ui-text--title--small">
              {title}
            </h3>
          </div>
        </SectionLink>
        <div className="section-tiles__icons">
          <div className="section-tiles__multi-icon-wrapper">
            <span className="section-tiles__private-icon section-tiles__icon">
              <PrivateIcon color="#fff" />
            </span>
          </div>
          <SmartMagazineControls
            section={section}
            buttonSet={buttonSet}
            isTooltipMenu
          />
        </div>
      </div>
    );
  }
}

SmartMagazineTile.propTypes = {
  section: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  selectedId: PropTypes.string,
  usageTrackSectionTap: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

SmartMagazineTile.defaultProps = {
  selectedId: null,
};

export default connector(
  connectModal,
  connectUsageTrackSectionTap,
)(withT(withHistory(withSelected(SmartMagazineTile))));
